import { ListItemIcon, ListItemText, MenuItem } from '@mui/material'
import { useIntl } from 'react-intl'
import { ButtonLink } from '../../../../components/wrappers/Button'
import { TtoggleDrawerOnMobile } from '../../../../containers/Sidebar/Sidebar'
import SportsEsportsIcon from '@mui/icons-material/SportsEsports'

interface MenuGameListProps {
  pathname: string
  nested?: string
  toggleDrawerOnMobile: TtoggleDrawerOnMobile
}

export const MenuGameList = ({
  pathname,
  nested,
  toggleDrawerOnMobile,
}: MenuGameListProps) => {
  const { formatMessage } = useIntl()

  const isDefaultPath = pathname.startsWith('/casino/game-list')

  return (
    <div onClick={toggleDrawerOnMobile}>
      <MenuItem
        className={nested}
        component={ButtonLink}
        href="/casino/game-list"
        selected={isDefaultPath}
      >
        <ListItemIcon>
          <SportsEsportsIcon />
        </ListItemIcon>
        <ListItemText
          primary={formatMessage({ id: 'casino.submenu.game_list.title' })}
        />
      </MenuItem>
    </div>
  )
}
